module.exports = __webpack_public_path__ + "img/Background_white.dfe3d2f5.png";